import type { CreditBalance } from '@src/domain/credits/entities/credit-balance.entity';
import type { CreditBalanceDTO } from '../dto/credit-balance.dto';

export class CreditBalanceMapper {
    static toDTO(entity: CreditBalance): CreditBalanceDTO {
        return {
            accountId: entity.accountId,
            userId: entity.userId,
            balance: {
                remainingCredits: entity.balance.remainingCredits,
                totalCredits: entity.balance.totalCredits,
                usedCredits: entity.balance.usedCredits,
                usagePercentage: entity.balance.usagePercentage,
            },
            currentPeriodStart: entity.currentPeriodStart,
            currentPeriodEnd: entity.currentPeriodEnd,
            isActive: entity.isActive,
        };
    }
}
